import { render, staticRenderFns } from "./EditDataRepairsLayout.vue?vue&type=template&id=61f4731d&scoped=true&"
import script from "./EditDataRepairsLayout.vue?vue&type=script&lang=js&"
export * from "./EditDataRepairsLayout.vue?vue&type=script&lang=js&"
import style0 from "./EditDataRepairsLayout.vue?vue&type=style&index=0&id=61f4731d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f4731d",
  null
  
)

export default component.exports